import { Link } from "react-router-dom";
import { TopBar } from "../components/Layout";

interface ResourceDoc {
  to: string;
  title: string;
  kind: string;
  description: string;
  icon: string;
}

const DOCS: ResourceDoc[] = [
  {
    to: "/resources/logos",
    title: "Logo & brand assets",
    kind: "Brand",
    description:
      "Five ActionConnect logo concepts (marks + light/dark lockups), the brand palette, " +
      "and downloadable SVGs. Use these when preparing decks, the marketing site, favicons, or print.",
    icon: "◆",
  },
  {
    to: "/resources/overview",
    title: "Full technical overview",
    kind: "Engineering",
    description:
      "The end-to-end system architecture: the five surfaces, request routing & tenant " +
      "isolation, database-per-tenant data model, provisioning lifecycle, workers/queues/Durable " +
      "Objects, security guardrails, and the cross-cutting services.",
    icon: "▤",
  },
  {
    to: "/resources/api-keys",
    title: "API keys & vendors",
    kind: "Operations",
    description:
      "Every external credential the platform depends on — Cloudflare, Mailgun, Microsoft Entra " +
      "and tenant IdPs — with the vendor, where to get each key, why it's needed, and which worker " +
      "it's set on.",
    icon: "⚷",
  },
  {
    to: "/resources/staging",
    title: "Staging & POC tenant",
    kind: "Environments",
    description:
      "The deployed staging environment (the 7 *.workers.dev URLs and shared resources) and the " +
      "proof-of-concept tenant — its host, IDs, and real admin login credentials. Staff-only.",
    icon: "❖",
  },
  {
    to: "/resources/pending",
    title: "Action items (from you)",
    kind: "Checklist",
    description:
      "What's still needed to reach production — secrets to set, decisions to make (logo, go-live " +
      "domain, staff SSO), and security housekeeping, each with its current status.",
    icon: "✓",
  },
];

export function ResourcesPage() {
  return (
    <>
      <TopBar crumbs="Resources" />
      <div className="content">
        <div className="page-head">
          <div>
            <h1>Resources</h1>
            <div className="sub">
              Reference material for ActionConnect staff — brand assets and the technical overview.
            </div>
          </div>
        </div>

        <div className="resource-grid">
          {DOCS.map((d) => (
            <Link key={d.to} to={d.to} className="resource-card">
              <span className="resource-icon" aria-hidden="true">
                {d.icon}
              </span>
              <span className="resource-kind">{d.kind}</span>
              <h2>{d.title}</h2>
              <p>{d.description}</p>
              <span className="resource-open">Open →</span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
